import React from 'react'
import TextInput from './TextInput'
import SelectInput from './SelectInput'
import { Col, FormLabel, Row } from '@themesberg/react-bootstrap'
import { useResponsive } from '../hooks/useResponsive'

function CustomForm({
  fields = [],
  handleChange = (f) => f,
  handleRadioChange = (f) => f,
}) {
  const { isMobile } = useResponsive();

  return (
    <Row>
      {fields.map((el, i) => {
        // Mobile-first column sizing
        const colProps = {
          xs: 12, // Always full width on mobile
          sm: el.sm || (isMobile ? 12 : 6),
          md: el.md || el.col || (isMobile ? 12 : 4),
          lg: el.lg || el.col || 4,
          className: isMobile ? "mb-3" : "mb-1"
        };

        if (el.type && el.type === 'select') {
          return (
            <Col {...colProps} key={i}>
              <SelectInput
                {...el}
                label={el.label}
                name={el.name}
                value={el.value}
                options={el.options || []}
                required={el.required}
                disabled={el.disabled}
                error={el.error}
                isInvalid={!!el.error}
                onChange={handleChange}
                size={isMobile ? 'lg' : 'sm'}
              />
            </Col>
          )
        } else if (el.type && el.type === 'custom') {
          return (
            <Col className={el.container} {...colProps} key={i}>
              {el.component()}
            </Col>
          )
        } else if (el.type === 'label') {
          return (
            <Col className={el.container} {...colProps} key={i}>
              <FormLabel
                className="mr-1 font-weight-bold"
                style={{ 
                  fontSize: isMobile ? '16px' : '17px',
                  marginBottom: isMobile ? '0.5rem' : '0.25rem'
                }}
              >
                {el.label}
              </FormLabel>
              <FormLabel style={{ fontSize: isMobile ? '14px' : '13px' }}>
                {el.value}
              </FormLabel>
              <FormLabel style={{ fontSize: isMobile ? '14px' : '13px' }}>
                {el.name}
              </FormLabel>
            </Col>
          )
        } else if (el.type === 'hidden') {
          return null
        } else {
          return (
            <Col {...colProps} key={i}>
              <TextInput
                {...el}
                size={isMobile ? 'lg' : 'sm'}
                label={el.label}
                type={el.type || 'text'}
                name={el.name}
                value={el.value}
                required={el.required}
                disabled={el.disabled}
                error={el.error}
                isInvalid={!!el.error}
                onChange={handleChange}
              />
            </Col>
          )
        }
      })}
    </Row>
  )
}

export default CustomForm
